import React, { PropsWithChildren } from "react";
//#region types
import { ExpandableListItemProps } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandableListItemFilter from "./expandableListItemFilter";
import ExpandableListItemActions from "./expandableListItemActions";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ExpandableListItem: React.FC<PropsWithChildren<ExpandableListItemProps>> = (props) => {
  const { id, onChange, expanded, listFilterProps } = props;

  const [reloadKey, setReloadKey] = React.useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    onChange(isExpanded ? id : undefined);
    if (isExpanded) {
      setReloadKey(reloadKey + 1);
    }
  };

  return (
    <Accordion className={cssExports.expandableListItem} expanded={expanded === id} onChange={handleChange}>
      <AccordionSummary
        classes={{
          root: cssExports.expandableListItemSummary,
          expandIconWrapper: cssExports.expandableListItemIcon,
          expanded: cssExports.expandableListItemSummaryExpanded,
          content: cssExports.expandableListItemSummaryContent,
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Grid container>
          <Grid item xs container direction="row" flexWrap="nowrap">
            <Grid item className={cssExports.expandableListItemTitle}>
              {props.title}
            </Grid>
            {listFilterProps ? <ExpandableListItemFilter key={reloadKey} {...listFilterProps} /> : <></>}
          </Grid>

          {props.headerSubContent ? (
            <Grid item className={cssExports.expandableListItemSubContent}>
              {props.headerSubContent}
            </Grid>
          ) : (
            <></>
          )}

          <ExpandableListItemActions headerHoverActions={props.headerHoverActions} />
        </Grid>
      </AccordionSummary>
      <AccordionDetails>{props.children}</AccordionDetails>
    </Accordion>
  );
};

export default ExpandableListItem;
